if (window.__bundleProgressInit) {
  // Script may be included from product block and cart drawer on the same page.
} else {
  window.__bundleProgressInit = true;

  document.addEventListener("DOMContentLoaded", () => {
    const progressContainers = document.querySelectorAll(
      "[data-bundle-progress]",
    );

    progressContainers.forEach((progressContainer) => {
      const titleEl = progressContainer.querySelector(".bundle-progress__title");
      const titleTemplate = titleEl
        ? titleEl.getAttribute("data-title-template")
        : null;
      const maxTitle = titleEl ? titleEl.getAttribute("data-max-title") : null;
      const steps = progressContainer.querySelectorAll(".bundle-progress__step");
      const arrows = progressContainer.querySelectorAll(
        ".bundle-progress__arrow",
      );

      const productForm = progressContainer.closest(".product-info") || document;
      const qtyInput = productForm.querySelector('input[name="quantity"]');
      const variantIdInput = productForm.querySelector('input[name="id"]');

      let cartQty = 0;
      const hideWhenEmpty = progressContainer.hasAttribute(
        "data-bundle-progress-hide-empty",
      );

      const updateUI = () => {
        const totalQty = cartQty;

        if (hideWhenEmpty) {
          const isEmpty = totalQty === 0;
          progressContainer.hidden = isEmpty;
          progressContainer.classList.toggle("bundle-progress--empty", isEmpty);
        }

        let nextTarget = null;
        let lastActiveStep = null;

        steps.forEach((step) => {
          const stepQty = parseInt(step.getAttribute("data-qty"), 10);
          if (stepQty <= totalQty) {
            step.classList.add("is-active");
            step.classList.remove("is-last-active");
            lastActiveStep = step;
          } else {
            step.classList.remove("is-active", "is-last-active");
            if (!nextTarget && step.hasAttribute("data-target")) {
              nextTarget = step;
            }
          }
        });

        if (lastActiveStep) {
          lastActiveStep.classList.add("is-last-active");
        }

        arrows.forEach((arrow) => {
          const arrowQty = parseInt(arrow.getAttribute("data-qty"), 10);
          if (arrowQty <= totalQty) {
            arrow.classList.add("is-active");
          } else {
            arrow.classList.remove("is-active");
          }
        });

        if (titleEl && titleTemplate && maxTitle) {
          if (nextTarget) {
            const targetQty = parseInt(nextTarget.getAttribute("data-qty"), 10);
            const targetDiscount = nextTarget.getAttribute("data-discount") || "";
            const itemsNeeded = targetQty - totalQty;

            if (itemsNeeded > 0) {
              titleEl.textContent = titleTemplate
                .replace("{count}", itemsNeeded)
                .replace("{discount}", targetDiscount);
            } else {
              titleEl.textContent = maxTitle;
            }
          } else {
            titleEl.textContent = maxTitle;
          }
        }
      };

      steps.forEach((step) => {
        if (step.hasAttribute("data-target")) {
          step.addEventListener("click", () => {
            const stepQty = parseInt(step.getAttribute("data-qty"), 10);
            if (qtyInput) {
              const neededQty = stepQty - cartQty;
              qtyInput.value = neededQty > 0 ? neededQty : 1;
              qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }
      });

      const fetchCartAndUpdate = () => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((res) => res.json())
          .then((cart) => {
            cartQty = cart.items.reduce((sum, item) => {
              const type = (item.product_type || "").toLowerCase().trim();
              return type === "bundle" ? sum : sum + item.quantity;
            }, 0);

            updateUI();
          })
          .catch((e) => {
            console.error("Bundle Progress: Error fetching cart", e);
            updateUI();
          });
      };

      fetchCartAndUpdate();

      document.addEventListener("on:cart:change", fetchCartAndUpdate);
      document.addEventListener("on:cart:add", fetchCartAndUpdate);
      document.addEventListener("on:cart:after-merge", fetchCartAndUpdate);

      if (variantIdInput) {
        variantIdInput.addEventListener("change", fetchCartAndUpdate);
      }
    });
  });
}
